import React from 'react';

import Admin from 'hive-admin';
import FieldText from 'hive-admin/src/components/FieldText';
import { LinkOutlined } from '@ant-design/icons';

import copyToClipboard from '../helpers/copyToClipboard';

export default class FieldSlug extends FieldText {
  static config = {
    ...FieldText.config,
    copyLinkValue: null,
    copyLinkSegments: [],
    copyLinkMessage: 'Copied to clipboard!',
    copyLinkEncode: false,
    label: 'Link',
    placeholder: 'Link',
  }

  renderInput(props) {
    const {
      copyLinkValue,
      copyLinkSegments,
      copyLinkMessage,
      copyLinkEncode = false,
    } = this.props;
    const extraProps = {};
    extraProps.addonBefore = '.../';
    extraProps.addonAfter = (
      <LinkOutlined
        onClick={(event) => {
          const copyLinkSegmentsValue = copyLinkSegments
          .map(segment => segment(
            this.props,
            event,
          ))
          .filter(segment => segment && segment.length)
          .join('/');
          copyToClipboard(
            `${
              copyLinkSegmentsValue.length
              ? `${copyLinkSegmentsValue}`
              : ''
            }${
              props.value && props.value.length
              ? (
                    copyLinkValue === false
                  ? ''
                  : copyLinkValue
                  ? copyLinkValue(props.value, props)
                  : `/${props.value}`
                )
              : ''
            }`,
            copyLinkMessage,
            copyLinkEncode,
          );
        }}
      />
    );
    return super.renderInput({
      ...extraProps,
      ...props,
    });
  }
}

Admin.addToLibrary(
  'FieldSlug',
  config => FieldSlug.create(config),
);
